import { render } from "./stockUpload.vue?vue&type=template&id=02798726"
import script from "./stockUpload.vue?vue&type=script&lang=js"
export * from "./stockUpload.vue?vue&type=script&lang=js"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__